import { createLocalizedClient, defaultJsonHeaders } from '@/http/client';

const client = createLocalizedClient({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers: defaultJsonHeaders,
    withCredentials: true,
    withXSRFToken: true
});

export default abstract class Auth {
    public static client = client;

    public static getCsrfCookie() {
        return Auth.client.get('/sanctum/csrf-cookie');
    }

    public static login(data: { email: string; password: string; remember?: boolean | null }) {
        return Auth.client.post('/login', data);
    }

    public static register(data: { name: string; email: string; password: string; password_confirmation: string }) {
        return Auth.client.post('/register', data);
    }

    public static forgotPassword(email: string) {
        return Auth.client.post('/forgot-password', { email });
    }

    public static resetPassword(data: { token: string; email: string; password: string; password_confirmation: string }) {
        return Auth.client.post('/reset-password', data);
    }

    public static twoFactorChallenge(code: string) {
        return Auth.client.post('/two-factor-challenge', { code, recovery_code: code });
    }

    public static confirmPassword(password: string) {
        return Auth.client.post('/user/confirm-password', { password });
    }

    public static resendVerificationEmail() {
        return Auth.client.post('/email/verification-notification');
    }

    public static logout() {
        return Auth.client.post('/logout');
    }

    public static activateTwoFactorAuthentication() {
        return Auth.client.post('/user/two-factor-authentication');
    }

    public static confirmTwoFactorAuthentication(code: string) {
        return Auth.client.post('/user/confirmed-two-factor-authentication', { code });
    }

    public static getTwoFactorQrCode() {
        return Auth.client.get('/user/two-factor-qr-code');
    }

    public static getTwoFactorSecretKey() {
        return Auth.client.get('/user/two-factor-secret-key');
    }

    public static getTwoFactorRecoveryCodes() {
        return Auth.client.get('/user/two-factor-recovery-codes');
    }

    public static resetTwoFactorRecoveryCodes() {
        return Auth.client.post('/user/two-factor-recovery-codes');
    }

    public static deactivateTwoFactorAuthentication() {
        return Auth.client.delete('/user/two-factor-authentication');
    }

    public static updatePassword(data: { current_password: string; password: string; password_confirmation: string }) {
        return Auth.client.put('/user/password', data);
    }

    public static updateProfile(data: { name: string; email: string; language: 'en' | 'nl' }) {
        return Auth.client.put('/user/profile-information', data);
    }
}
